/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Min_Spend_InvalidInputs */

const vi_shop_tier_min_spend_invalid = /** @type {(inputs: Shop_Tier_Min_Spend_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mốc chi tiêu phải là số tiền nguyên, không âm.`)
};

/**

* @param {Shop_Tier_Min_Spend_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_min_spend_invalid = /** @type {((inputs?: Shop_Tier_Min_Spend_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Min_Spend_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_min_spend_invalid(inputs)
});